import { useSelector } from 'react-redux';
import { RootState } from '../Store';

export const useLoanRequestSelector = () => {
   return useSelector((state: RootState) => state.LoanRequest);
};
